import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// import './fonts/Montserrat_Alternates/MontserratAlternates-Regular.ttf';
// import './fonts/Montserrat_Alternates/MontserratAlternates-Italic.ttf';
// import './fonts/Montserrat_Alternates/MontserratAlternates-Light.ttf';
// import './fonts/Montserrat_Alternates/MontserratAlternates-LightItalic.ttf';
// import './fonts/Montserrat_Alternates/MontserratAlternates-SemiBold.ttf';
// import './fonts/Montserrat_Alternates/MontserratAlternates-Bold.ttf';
import './fonts/Montserrat/Montserrat-VariableFont_wght.ttf';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
